import { gql } from 'apollo-angular';

export const UPDATE_TEMPLATE_VARIANT_MUTATION = gql`
  mutation updateTemplateVariant($templateVariantInput: TemplateVariantInput) {
    updateTemplateVariant(templateVariantInput: $templateVariantInput) {
      id
    }
  }
`;

export const CREATE_TEMPLATE_VARIANT_MUTATION = gql`
  mutation createTemplateVariant($templateVariantInput: TemplateVariantInput) {
    createTemplateVariant(templateVariantInput: $templateVariantInput) {
      id
    }
  }
`;

export const DELETE_TEMPLATE_VARIANT_MUTATION = gql`
  mutation deleteTemplateVariant($templateVariantId: UUID) {
    deleteTemplateVariant(templateVariantId: $templateVariantId)
  }
`;
